/* メインビジュアル sync controller 間の公開契約だけを初期化する。各 controller より先に読み込む */
(() => {
  const SYNC_READY_EVENT = 'aureme:main-visual-sync:ready';
  /*
   * controller 追加時は REQUIRED_CONTROLLER_KEYS と
   * sections/aureme-main-visual.liquid の script 順も合わせて更新する。
   * controller 側の fallback が積んだ pending は、この contract で消費する。
   */
  const REQUIRED_CONTROLLER_KEYS = [
    'ActiveMediaSync',
    'MainVisualSliderSync',
    'MainVisualUnderlayReadySync',
  ];
  const REQUIRED_SHARED_KEYS = [
    'constants',
    'helpers',
    'normalizeMainVisualAutoplayDelay',
    'normalizeMainVisualSliderEffect',
  ];
  const DEFAULT_CONSTANTS = {
    UNDERLAY_READY_EVENT: 'aureme:main-visual-underlay:ready',
    UNDERLAY_READY_CLASS: 'aureme-main-visual-underlay-ready',
  };
  function notifyMainVisualSyncReady() {
    window.dispatchEvent(new Event(SYNC_READY_EVENT));
  }

  function isMainVisualSyncReady(Sync) {
    const hasRequiredControllers = REQUIRED_CONTROLLER_KEYS.every((key) => Boolean(Sync?.[key]));
    const hasRequiredSharedKeys = REQUIRED_SHARED_KEYS.every((key) => Boolean(Sync?.[key]));

    return hasRequiredControllers && hasRequiredSharedKeys;
  }

  function notifyMainVisualSyncReadyIfReady(Sync) {
    if (isMainVisualSyncReady(Sync)) {
      notifyMainVisualSyncReady();
    }
  }

  function queueMainVisualSyncMembers(syncMembers) {
    window.AuremeMainVisual = window.AuremeMainVisual || {};
    window.AuremeMainVisual.pendingSyncMembers = window.AuremeMainVisual.pendingSyncMembers || [];
    window.AuremeMainVisual.pendingSyncMembers.push(syncMembers);

    return null;
  }

  function registerOrQueueMainVisualSyncMembers(syncMembers) {
    const Sync = window.AuremeMainVisual?.Sync;
    if (typeof Sync?.register === 'function') return Sync.register(syncMembers);

    return queueMainVisualSyncMembers(syncMembers);
  }

  function createMainVisualSync(syncMembers = {}) {
    const currentNamespace = window.AuremeMainVisual || {};
    const currentSync = currentNamespace.Sync || {};
    const { constants, helpers, ...members } = syncMembers;
    const Sync = {
      ...currentSync,
      ...members,
      constants: {
        ...DEFAULT_CONSTANTS,
        ...currentSync.constants,
        ...constants,
      },
      isReady: isMainVisualSyncReady,
      notifyReadyIfReady: notifyMainVisualSyncReadyIfReady,
      register: registerMainVisualSyncMembers,
      readyEventName: SYNC_READY_EVENT,
    };

    if (currentSync.helpers || helpers) {
      Sync.helpers = {
        ...currentSync.helpers,
        ...helpers,
      };
    }

    window.AuremeMainVisual = {
      ...currentNamespace,
      registerSyncMembers: registerOrQueueMainVisualSyncMembers,
      Sync,
    };

    return Sync;
  }

  function registerMainVisualSyncMembers(syncMembers) {
    const Sync = createMainVisualSync(syncMembers);
    notifyMainVisualSyncReadyIfReady(Sync);

    return Sync;
  }

  function consumePendingMainVisualSyncMembers() {
    const currentNamespace = window.AuremeMainVisual || {};
    const pendingSyncMembers = Array.isArray(currentNamespace.pendingSyncMembers)
      ? currentNamespace.pendingSyncMembers
      : [];
    delete currentNamespace.pendingSyncMembers;

    let Sync = window.AuremeMainVisual?.Sync || null;
    for (const syncMembers of pendingSyncMembers) {
      Sync = registerMainVisualSyncMembers(syncMembers);
    }

    return Sync;
  }

  const Sync = createMainVisualSync();
  const registeredSync = consumePendingMainVisualSyncMembers() || Sync;

  /* Theme Editor 再評価で main visual.js が先に待機する場合もあるため、ready event を再度 flush する */
  notifyMainVisualSyncReadyIfReady(registeredSync);
})();
